package one.healthium.onboarding.ui.components

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.ime
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

@Composable
internal fun ColumnScope.DynamicSpacer(weight: Float) {
    val keyboardVisible = WindowInsets.ime.asPaddingValues().calculateBottomPadding() != 0.dp
    val spacer by animateFloatAsState(if (keyboardVisible) 0.05f else weight)
    Spacer(Modifier.weight(spacer))
}